import React from 'react';

const Spinner = ({ 
  size = 40, 
  color = '#4fa94d', 
  thickness = 4,
  className = '',
  center = false 
}) => {
  const containerStyle = center ? {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100px'
  } : {};

  return (
    <div style={containerStyle} className={className}>
      <div
        className="custom-spinner"
        style={{
          width: size,
          height: size,
          border: `${thickness}px solid #f3f3f3`,
          borderTop: `${thickness}px solid ${color}`,
          borderRadius: '50%',
        }}
      />
    </div>
  );
};

export default Spinner;
